import { API_URL } from "../../constants/axios";
import { fetchApi } from "../fetch";

export const getAutomateMessage = async (id, entrypointId) => {
    const params = new URLSearchParams({id});
    if (entrypointId) params.append("entrypointId", entrypointId);

    const res = await fetchApi.get(API_URL.AUTOMATE_MESSAGE + "?" + params.toString());
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};

export const getAutomateMessageList = async (entrypointId) => {
    const res = await fetchApi.get(API_URL.AUTOMATE_MESSAGE_LIST + (entrypointId ? `?entrypointId=${entrypointId}` : ''));
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};

export const postAutomateMessage = async (conditionData) => {
    const res = await fetchApi.post(API_URL.AUTOMATE_MESSAGE_LIST, conditionData);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};

export const postStatusAutomateMessage = async (conditionData) => {
    const res = await fetchApi.post(API_URL.AUTOMATE_MESSAGE_USED, conditionData);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};

export const aiGenerateAutomateMessage = async (generateData) => {
    const res = await fetchApi.post(API_URL.AUTOMATE_AI_GENERATE, generateData, true);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};


export const aiGenerateAutomateImage = async (automateData) => {
    const res = await fetchApi.post(API_URL.AUTOMATE_AI_GENERATE_IMAGE, automateData);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
};

/**
 * 설문조사 자동화(CUSTOMER_POLL) 버튼에 넣을 진입점 링크 후보.
 * `[{id, name, linkUrl, projectId, projectName, surveyUsed, surveyReady}]` — 서버가 설문 도달 가능한 것부터 정렬해 준다.
 */
export const getCustomerPollEntryPoints = async () => {
    const res = await fetchApi.get(API_URL.AUTOMATE_POLL_ENTRYPOINTS);
    if (res.status === 200) {
        return res.data;
    } else {
        return null;
    }
};

/**
 * 설문조사 자동화(CUSTOMER_POLL) 추가 — 관리자 전용. 꺼진 상태로 만들어지고, 이미 있으면 그 id 를 돌려준다.
 * 성공 시 `{automateId, created}`, 실패 시 null.
 */
export const createCustomerPollAutomation = async () => {
    const res = await fetchApi.post(API_URL.SYSADMIN_CREATE_CUSTOMER_POLL, {});
    if (res.status === 200) {
        return res.data?.data ?? null;
    } else {
        return null;
    }
};
